<template>
    <div>
        <BaseInputSelect
            v-model="account.compliance_profiles.esac.risk_tolerance.risk_tolerance"
            name="risk_tolerance.risk_tolerance"
            :required="isRequiredNaturalComplianceProfileAttribute('risk_tolerance', 'risk_tolerance')"
            :options="riskToleranceOptions"
            :label="$t('risk_tolerance.label')"></BaseInputSelect>
    </div>
</template>

<script setup lang="ts">
import { usePersonalAccountDataState } from '../../../../utilities/account/useAccountDataPersonal'
import {
    getNaturalWidgetFormValidationRules,
    initializeNaturalWidgetForm,
    isRequiredNaturalComplianceProfileAttribute,
} from './forms'
import BaseInputSelect from '../../../base/BaseInputSelect.vue'
import { computed } from 'vue'
import { RiskToleranceOption } from '../../../../typings'
import { i18n } from '../../../../localization'

const riskToleranceOptions = computed(() => {
    return Object.keys(RiskToleranceOption).map((key) => {
        return {
            key: RiskToleranceOption[key],
            label: i18n.global.t('risk_tolerance.' + RiskToleranceOption[key]),
        }
    })
})
const { naturalProfile: account } = usePersonalAccountDataState()
initializeNaturalWidgetForm(getNaturalWidgetFormValidationRules('risk_tolerance'))
</script>
